import React from "react";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import { StyledGreyBadgeNoBackgroundOnPrint } from "../styled/badge";
import { TypographyBoldOnPrint } from "../styled";
import { formatFinance } from "../../utils/formatters";

export default function ChannelReportSummaryRow({
  method,
  finance,
  amount,
  isBold = false,
  backgroundColor = "transparent",
}) {
  return (
    <StyledGreyBadgeNoBackgroundOnPrint
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      backgroundcolor={backgroundColor}
    >
      <Box
        display="flex"
        justifyContent="start"
        alignItems="center"
        sx={{
          flex: 1, // Take up equal space
          "@media print": {
            flex: 1,
          },
        }}
      >
        <TypographyBoldOnPrint
          variant="body1"
          textAlign="left"
          fontWeight={isBold ? "bold" : "normal"}
          printsize={11}
        >
          {method}
        </TypographyBoldOnPrint>
      </Box>
      <Box
        display="flex"
        justifyContent="end"
        alignItems="center"
        sx={{
          flex: 1, // Take up equal space
        }}
      >
        <TypographyBoldOnPrint
          variant="body1"
          textAlign="right"
          fontWeight={isBold ? "bold" : "normal"}
          printsize={11}
        >
          {amount} Pedidos
        </TypographyBoldOnPrint>
      </Box>
      <Box
        display="flex"
        justifyContent="end"
        alignItems="center"
        sx={{
          flex: 1, // Take up equal space
        }}
      >
        <TypographyBoldOnPrint
          variant="body1"
          textAlign="right"
          fontWeight={isBold ? "bold" : "normal"}
          printsize={11}
        >
          {formatFinance(finance)}
        </TypographyBoldOnPrint>
      </Box>
    </StyledGreyBadgeNoBackgroundOnPrint>
  );
}
